export const DEPOSIT_NETWORK_LABEL = 'USDT TRC-20';
export const DEPOSIT_NETWORK_SHORT = 'TRC-20';
export const MIN_CARD_BALANCE_TOP_UP_USD = '25';
export const MIN_DEPOSIT_TRANSACTION_USD = '5';
export const DEPOSIT_ADDRESS = 'TJmv5d8Qk2nQp7XyR4bV2sd9fA1xZ';
export const DEPOSIT_MIN_USDT = 50;
export const DEPOSIT_MIN_NOTE =
  'Minimum 50 USDT · funds arrive ≈ 1–3 min after 1 network confirmation';
export const DEPOSIT_WARNING =
  'Send only USDT (TRC-20) from your own wallet. Verify the full address above.';

export const MOCK_DEPOSIT = {
  amountUsdt: '500',
  amountUsd: '$500.00',
  totalConfirmations: 20,
  txHash: '0xa1f3…9cD2',
  txHashFull: '0xa1f3b8c2d9e4f7a1b3c5d6e8f9a0b2c4d5e6f7a8b9c0d1e2f3a4b5c6d7e8f9cD2',
  failureReason:
    'Sent from an address that is not your own (whitelist rule). Contact support to recover.',
};

export function formatDepositDate(date = new Date()) {
  return date.toLocaleString('en-GB', {
    day: 'numeric',
    month: 'short',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
}
